import { _ as _taggedTemplateLiteralLoose, D as DWEB_RECENT_SEARCH_CARD, a as _extends, L as LOAD_EVENT, P as PdtInstance } from '../../../dist/pdt-d1924dde.esm.js';
import React, { useEffect } from 'react';
import gtmPush from '@growth/gtm-push';
import styled from 'styled-components';
import { font } from '@growth/app-theme';
import '@growth/browser-storage';
import '@growth/dom-event-emitter';
import '@growth/custom-hooks/useAppLinkQr';
import { e as DwebRecentSearchCardText } from '../../../dist/writting-560a6a45.esm.js';
import '@growth/pdt-track';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var roboto = font.fontFamilyRoboto;
var ScanWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbackground: #fff;\n\twidth: 280px;\n\theight: 114px;\n\tborder: 1px solid #dcdcdc;\n\tborder-radius: 8px;\n\tflex-shrink: 0;\n"])));
var ValidLeftWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tpadding-left: 16px;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
var ExtraOffText = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tfont-family: ", ";\n\tfont-weight: 700;\n\tfont-size: 22px;\n\tline-height: 36px;\n\tletter-spacing: 0.2px;\n\tcolor: #5f5f5f;\n\tmax-width: 112px;\n\tflex: 1;\n"])), roboto);
var CopyTxtText = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tpadding: 10px 0;\n\tfont-family: ", ";\n\tmargin-left: 0;\n\tborder-top: 2px solid #e1e7ee;\n\tcolor: #5f5f5f;\n"])), roboto);
var BarcodeImg = styled.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\twidth: 75px;\n\theight: auto;\n"])));
var ScanText = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tfont-size: 10px;\n\tcolor: #647a97;\n\topacity: 0.8;\n\ttext-align: center;\n\tpadding-top: 2px;\n\tfont-family: ", ";\n"])), roboto);
var BarcodeImgWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tbackground: #ffffff;\n\tborder-radius: 4px;\n\tmargin-right: 32px;\n\ttext-align: center;\n"])));
var HappyPhoneIcon = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\tbackground-repeat: no-repeat;\n\tpadding-right: 14px;\n\tdisplay: inline-block;\n\twidth: 10px;\n\theight: 10px;\n\tbackground-size: contain;\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='12' fill='none'%3E%3Cg fill='%23000' opacity='.6'%3E%3Cpath d='M1.863 0A1.052 1.052 0 0 0 .814 1.05v9.006a1.051 1.051 0 0 0 1.05 1.05H6.76a1.052 1.052 0 0 0 1.05-1.05V1.049A1.052 1.052 0 0 0 6.76 0H1.863Zm4.898 10.406H1.863a.352.352 0 0 1-.35-.35V8.47h5.593v1.586a.352.352 0 0 1-.355.35h.01Zm.345-9.357V7.77H1.509V1.05a.352.352 0 0 1 .35-.35h4.897a.352.352 0 0 1 .35.35Z'/%3E%3Cpath d='M4.307 8.727a.658.658 0 1 0 0 1.316.658.658 0 0 0 0-1.316Z'/%3E%3C/g%3E%3C/svg%3E\");\n"])));

var DwebRecentSearchAppCard = function DwebRecentSearchAppCard(props) {
  var _hocProps$userDetails;

  var lobName = props.lobName,
      hocProps = props.hocProps,
      page = props.page;
  var linkDetails = {
    campaign: 'mweb2app-qr-recent-search-dweb',
    tagid: '0'
  };
  var pdt = PdtInstance();
  var gtmCommonKeys = {
    lob: lobName,
    campaign: linkDetails.campaign,
    ab_experiment: (hocProps == null ? void 0 : hocProps.experimentKey) + ":" + (hocProps == null ? void 0 : hocProps.experimentValue),
    tag: linkDetails.tagid + "-" + page,
    kind: DWEB_RECENT_SEARCH_CARD
  };
  pdt.setCommonKeys({
    campaign: gtmCommonKeys.campaign,
    bannerType: gtmCommonKeys.kind,
    tagid: Number(linkDetails == null ? void 0 : linkDetails.tagid),
    lobName: lobName,
    page: page,
    experimentKey: hocProps == null ? void 0 : hocProps.experimentKey,
    experimentValue: hocProps == null ? void 0 : hocProps.experimentValue,
    uuid: hocProps == null ? void 0 : (_hocProps$userDetails = hocProps.userDetails) == null ? void 0 : _hocProps$userDetails.uuid
  });
  useEffect(function () {
    gtmPush(_extends({
      event: LOAD_EVENT
    }, gtmCommonKeys));
    pdt.sendPdtEvent({
      event: LOAD_EVENT
    });
  }, []);

  var Card = function Card() {
    return /*#__PURE__*/React.createElement(ScanWrapper, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ValidLeftWrapper, null, /*#__PURE__*/React.createElement(ExtraOffText, {
      dangerouslySetInnerHTML: {
        __html: DwebRecentSearchCardText.heading
      }
    }), /*#__PURE__*/React.createElement(CopyTxtText, {
      className: "offer"
    }, /*#__PURE__*/React.createElement(HappyPhoneIcon, null), DwebRecentSearchCardText.description)), /*#__PURE__*/React.createElement(BarcodeImgWrapper, null, /*#__PURE__*/React.createElement(BarcodeImg, {
      src: "https://gos3.ibcdn.com/mweb2app-qr-recent-search-dweb-1673516405.jpeg"
    }), /*#__PURE__*/React.createElement(ScanText, null, DwebRecentSearchCardText.qrLabel))));
  };

  return /*#__PURE__*/React.createElement(Card, null);
};

DwebRecentSearchAppCard.defaultProps = {
  hocProps: undefined
};

export { DwebRecentSearchAppCard as DwebRecentSearchAppCardBasic };
